import "./lib/stimulus-autoloader";

// TOPのみ
import "./modules/fetch.ts";
import "./modules/fadeIn.ts";

// ABOUTのみ
import "./modules/carousel.ts";
